export const BASEURL = process.env.REACT_APP_API_URL

//LOGIN_WITJ_SSO :
export const LOGIN = "/Auth/Login"
export const LOGIN_WITH_SSO = "/Auth/LoginwithSSO"
//redirect login api
export const REDIRECT_LOGIN_WITH_SCREEN = "/Auth/GetUserDataByUserId"
//FORGOT PASSWORD:
export const FORGOTPWD = "/Auth/ForgetPassword?email="

//CHANGE PASSWORD
export const CHANGEPWD = "/Auth/ChangePassword"

// TIMESHEET API:
export const POST_WORKREPORT = "/TimeSheet/GetWorkReports"
export const POST_TIMESHEET = "/TimeSheet/GetTimeSheetByDateRange"

// TEAMS API:
// export const POST_TEAMS = "TimeSheet/GetTeamTimeSheetByDateRange"
export const POST_TEAMS = "TimeSheet/GetTeamReportsByUser"
export const POST_APPROVES_TEAMS = "/TimeLog/ApproveEvaluationHours"
export const POST_REJECTS_TEAMS = "TimeLog/RejectEvaluationHours"
export const GET_EVALUATION_HOURS = "/TimeLog/GetOnEvaluationHours"
export const GET_TIMELOGBY_DATE = "/Timelog/TimeLogByDate"
export const PUT_FLAG_TIMELOG_INVALID = "/TimeLog/FlagTimeLogInvalid"
export const GET_ACTIVITYLOG = "/Timelog/GetActivityLog"
export const POST_MOVE_ID_HOURS_TIMELOG = "/TimeSheet/MoveHours"
export const POST_ADD_MANUAL_ENTRY_TIMELOG = "/TimeSheet/ManualHours"
export const POST_ADD_CHANGE_STATUS_TIMELOG = "/TimeSheet/ChangeStatus"
export const GET_MOVE_ID_HOURS_FROMID_SELECT = "/Category/GetSubCategory"
export const GET_MOVE_ID_HOURS_TOID_SELECT = ""
export const POST_REPORT_QUICK_SEND_TO_CLIENTS = "/ReportQuickSend"
export const GET_HOURS_SUMMARY_REPORTS ="/TimeLog/GetHoursSummaryReport"
export const UPDATE_BOOK_MARKS ="/Teams/BookMarkProject"



// Export WFH (Work From Home) Detailed Report
export const  EXPORT_WFH   = "/Report/ExportDetailedWorkFromHomeReport";
// Track Profile
export const GET_PROFILE_DATA = "/TrackingProfiles"
export const GET_ALL_CATEGORY = "TrackingProfiles/TrackingProfileLookup"
export const POST_UPDATE_PROFILE = "/TrackingProfiles/SaveTrackingProfile"
export const POST_DELETE_PROFILE = "/TrackingProfiles/DeleteTrackingProfile"
export const POST_UPDATE_WORK_REPORT = "/TimeSheet/BulkInsertUpdateWorkReport"
export const POST_REWRITE_WORK_REPORT = "/TimeSheet/RewriteWorkReport"

// ACCESS GROUP SETTING
export const GET_ALL_ACCESSGROUP_LIST = "/Users/GetAccessGroupSettings"
export const POST_UPDATE_ACCESSGROUP = "/Users/SaveAccessGroupSettings"

// create team
export const GET_CREATE_TEAMLOOKUP = "/Teams/CreateTeamLookup"
export const GET_CREATE_TEAMS = "/Teams/GetTeams"
export const GET_CREATE_TEAM = "Teams/CreateTeam"
// export const GET_PROJECT_TEAM = "Timesheet/GetTeamReportSheetByDateRange"
export const GET_PROJECT_TEAM = "Timesheet/GetTeamReportsByCategory"

//approve team
export const POST_APPROVE_TEAM = "Teams/ApproveTeam"
export const POST_REJECT_TEAM = "Teams/RejectTeam"
export const POST_END_TEAM = "Teams/EndTeam"
export const POST_UPDATE_TEAMS = "/Teams/UpdateTeam"
export const POST_UPDATE_TEAMS_NO_APPROVED = "/Teams/UpdateUnApprovedTeam"

// Get Agent
export const GET_AGENT = "/GetAllAgentDetails"
// get project status
export const GET_PROJECT_STATUS = "/Teams/GetProjectStatus"
// get project status total hours
export const GET_PROJECT_STATUS_TOTAL_HOUR = "/Category/GetProjectTotalHours"

// Get Agent
export const GET_BILLING_TYPES = "/GetAllBillingTypes"

//Manage Team
export const GET_CATEGORY = "/Category/GetCategory"
export const SAVE_GATEGORY = "/Category/SaveCategory"
export const NEW_USER = "/Category/CreateCategoryUser"
export const NEW_SUB_CATEGORY = "Category/SaveSubCategory"
export const CATEGORY_USER_DELETE = "Category/DeleteCategoryUser"
export const USERS_BY_PROJECT = "/Category/GetUsersBySubCategoryId"
export const COMPANY_DETAILS = "Company/GetCompanySettings"
export const SUMMARY_DETAILS = "Company/UpdateCompanySettings"
export const GET_CATEGORY_USER = "/Category/GetCategoryUserEmailAddress"
export const SEND_REPORT = "/SendReportForSelectedProject"

//User List
export const POST_USER_DATA = "/Users/GetUsers"

// ADD NEW USER
export const POST_NEW_USER_DATA = "/Auth/CreateUser"
export const PUT_UPDATE_NEW_USER = "/Auth/UpdateUserData"
export const POST_BULK_UPLOAD = "Auth/BulkUploadUsers"

// USER DEVICES / PRIMARY COMPUTER
export const GET_USER_DEVICES = "/User/GetUserDevices"
export const PUT_SET_PRIMARY_DEVICE = "/User/SetPrimaryDevice"

// PRIMARY DEVICE HISTORY (effective-dated, admin)
export const GET_USER_PRIMARY_DEVICE_HISTORY = "/User/GetUserPrimaryDeviceHistory"
export const POST_ADD_USER_PRIMARY_DEVICE = "/User/AddUserPrimaryDevice"
export const PUT_UPDATE_USER_PRIMARY_DEVICE = "/User/UpdateUserPrimaryDevice"
export const DELETE_USER_PRIMARY_DEVICE = "/User/DeleteUserPrimaryDevice"

// UPDATE ATTENDANCE
export const UPDATE_ATTENDANCE = "/TimeSheet/UpdateAttendanceDetailsFlexiTracToERP"

// VALIDATE ATTENDANCE SYNC (FlexiTrac vs ERP)
export const POST_VALIDATE_ATTENDANCE_SYNC = "/Attendance/ValidateAttendanceSync"

// UPDATE TIMESHEET
export const UPDATE_TIMESHEET = "/TimeSheet/UpdateTimesheetDetailsFlexiTracToERP"

// ERP CRM CLIENTS (standard ERPNext "Customer" doctype)
export const GET_ERP_CLIENTS = "/CrmSync/Customers"      // GET list / POST sync-all
export const GET_ERP_CLIENT = "/CrmSync/Customer"        // GET detail / POST sync-one (+ `/${name}`)

// CRM ORGANIZATIONS (Frappe CRM "CRM Organization" doctype)
export const GET_CRM_ORGS = "/CrmSync/Organizations"     // GET list / POST sync-all
export const GET_CRM_ORG = "/CrmSync/Organization"       // GET detail (+ `/${name}`)
export const SYNC_CRM_ORG = "/CrmSync/Client"            // POST sync-one (+ `/${name}`)

// UPDATE NON REPORT PENALTY
export const UPDATE_PENALTY = "/Penalty/UpdatePenaltyPoints"

// COMPANY SIGNUP
export const COMPANY_REGISTER = "/Company/Register"

// USER SIGNUP
export const USER_SIGNUP = "/Auth/Register"

// PROJECT LIST
export const GET_ALL_PROJECT_LIST = "/Projects"

// SCREEN LIST
export const GET_SCREEN_VERIFIED_LIST = "/ScreenLog/GetScreenLogByAccountID"
export const POST_EXCLUDE_SCREEN = "/ScreenLog/ExcludeScreens"
export const POST_EXCLUDE_SCREEN_LOGS = "/ScreenLog/VerifyScreens"
export const POST_GET_SCREEN_LOGS = "/ScreenLog/GetScreenLogs"
export const GET_PROJECT_SUMMARY_REPORT_SCREENS = "/Report/GetProjectSummaryReportScreens"
export const GET_PROJECT_SUMMARY_REPORT = "/Report/GetProjectSummaryWorkReports"
//

export const GET_ACTIVITY_SUMMARY_LIST = "/TimeSheet/GetActivitySummary"
// Category user work report and screens
export const GET_ALL_WORK_PROJECT_LIST = "/Category/GetCategoryUserWorkReport"

// all get scrutiny notes get all data
export const GET_ALL_SCRUTINY_NOTE = "/ScrutinyNotes/GetAllScrutinyNotes"
// all get scrutiny notes get all data type
export const GET_ALL_SCRUTINY_NOTE_TYPE = "/ScrutinyNotes/GetAllScrutinyType"

// get, insert, update and  delete  GetAllNonWorkingHours
export const GET_ALL_NON_WORKING_HOURS = "/GetAllNonWorkingHours"
export const POST_ALL_NON_WORKING_HOURS = "/InsertUpdateNonWorkingHours"
export const DEL_ALL_NON_WORKING_HOURS = "/DeleteNonWorkingHoursById"

export const GET_ALL_WORK_PROJECT_SCREENS_LIST =
  "/Category/GetCategoryUserScreens"

export const POST_CREATE_CATEGORY_USER_LINK = "/Category/CreateCategoryUserLink"

export const CLIENT_VIEW_SCREENS_LIST = "/Client/ClientScreenView"
/* ------------------------------------------------------------------------------------- */

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"
export const TOP_SELLING_DATA = "/top-selling-data"
export const GET_EARNING_DATA = "/earning-charts-data"
export const GET_PRODUCT_COMMENTS = "/comments-product"
export const ON_LIKNE_COMMENT = "/comments-product-action"
export const ON_ADD_REPLY = "/comments-product-add-reply"
export const ON_ADD_COMMENT = "/comments-product-add-comment"

// upload application
export const POST_UPLOAD_APPLICATION = "/Application/UploadSetup"

// Add Users
export const ADD_USERS_FOR_PROJECTS = "/Account/CreateAccount"
//get api for hours report page employee
export const GET_HOURS_REPORTS = "/Report/GetHoursSummaryReport"

//get api for admin "Report submitted time" report page
export const GET_REPORT_SUBMITTED_TIME = "/Report/GetReportSubmittedTimeReport"

//get api for dropdown list webhooks 
export const GET_WEB_HOOKS_LIST = "/WebHook/GetWebhookProcessList"

//get api for dropdown list webhooks 
export const GET_WEB_HOOKS = "/WebHook/ListWebHook"

//post insert api for webhooks list
export const POST_WEB_HOOKS_INSERT = "/WebHook/InsertWebHook"

//post update for webhooks list
export const POST_WEB_HOOKS_UPDATE = "/WebHook/UpdateWebHook"

//put delete api for webhooks list
export const PUT_WEB_HOOKS_DELETE = "/WebHook/DeleteWebHook"

// get DETAILED work from home api 
export const GET_DETAILED_WORK_FORM_HOME = '/Report/GetDetailedWorkFromHomeReport'

// get summary work from home api 
export const GET_SUMMARY_WORK_FORM_HOME = '/Report/SummaryWorkFromHomeReport'

// update scrutiny status
export const UPDATE_SCRUTINY_STATUS_URL = '/ScrutinyNotes/UpdateScrutinyStatus'

// AI Usage Log
export const GET_AI_USAGE_LOG = '/AiUsageLog/GetAll'

// Workspace Audit
export const POST_WORKSPACE_AUDIT_SAVE = "/WorkspaceAudit/Save"
export const POST_WORKSPACE_AUDIT_LIST = "/WorkspaceAudit/GetList"
export const POST_WORKSPACE_AUDIT_DASHBOARD = "/WorkspaceAudit/GetDashboard"
export const POST_WORKSPACE_AUDIT_DETAIL = "/WorkspaceAudit/GetDetail"